<template>
  <div class="guest">
    <form class="signin-form">

      <grid :gap="3">
        <div class="is-flex justify-center"><logo width="10rem" /></div>
        <h3 class="title is-5 has-text-weight-light has-text-centered leading-spaced">Sign into your Snitch Account.</h3>
      </grid>

      <grid class="mb-2 mt-3">
        
        <email-input
          v-focus
          required
          classes="is-medium"
          placeholder="Email Address"
          store="auth"
        />

        <user-password-input
          reveal="toggle"
          reveal-class="is-medium"
          required
          classes="is-medium"
          placeholder="Password"
          field="password"
          mutation="updatePassword"
          store="auth"
        />

        <submit-button
          @submit="authenticate"
          :disabled="!canSignIn"
          :working="authenticating"
          class="ptb-2 is-primary is-rounded is-outlined is-medium mt-1 has-text-weight-bold">
          Sign In
        </submit-button>

        <route
          name="forgot-password"
          class="has-text-centered mt"
          :class="{ 'opacity-50 pointer-events-none': authenticating }">
          Forgot your password?
        </route>

        <hr />

        <h3 class="title is-4 has-text-white-ter has-text-weight-light has-text-centered">Not with us yet?</h3>

        <div class="buttons is-centered">
          <route
            :disabled="authenticating"
            name="signup"
            class="button is-primary has-text-weight-bold is-rounded">
            <span class="mlr-2">Try Snitch</span>
          </route>
        </div>
      </grid>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  data: () => ({
    authenticating: false,
  }),

  created() {
    this.$bus.$emit('set-title', 'Sign In')
  },

  methods: {
    stopAuthenticating(error) {
      this.authenticating = false
      const message = error?.response?.data?.error === 'invalid_request'
        ? 'Please provide both your email address and password to sign in.'
        : 'The email address and passord provided is incorrect. Please try again.'
      this.$toast.warning('Unable to sign in', message)
    },

    authenticate() {
      this.authenticating = true
      this.$store
        .dispatch('auth/authenticate')
        .then((data) => {

          if(data.two_factor === true) {
            this.$router.push({ name: '2fa-challenge'})
          } else {
            Promise.all([
              this.$store.dispatch('auth/loadUser'),
              this.$store.dispatch('auth/loadAccount'),
            ])
            .then(() => {
              this.authenticating = false
              this.$router.push({ name: 'dashboard' })
              this.$toast.info('Welcome back')
            }).catch(error => {
              console.log(error)
              this.authenticating = false
            })
          }
        })
        .catch((error) => {
          this.authenticating = false
          setTimeout(this.stopAuthenticating(error), 2000)
        })
    },
  },

  computed: {
    ...mapGetters('auth', [
      'canSignIn'
    ])
  }

}
</script>
